<div class="email-container">
  <div class="email-header">
    <div class="header-left">
      <button class="send-btn allow-hover" [disabled]="!emailForm.get('to')?.valid" (click)="onSubmit()">
        <i class="fa-solid fa-share"></i> Send
      </button>
    </div>
    <div style="flex: 1; text-align: center">
      <h3 style="margin: 0">Email</h3>
    </div>
    <div class="header-right">
      <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModalClick()"></button>
    </div>
  </div>
  <hr />
  <form [formGroup]="emailForm" class="email-fields">
    <!-- To -->
    <div class="field-row">
      <button class="btn btn-outline-primary to-btn" style="margin-right: 10px" type="button">To</button>
      <ng-select class="email-input" [items]="to_values" bindLabel="email" bindValue="email" [multiple]="true"
        [hideSelected]="true" [minTermLength]="2" [virtualScroll]="true" [minTermLength]="3"
        typeToSearchText="Please enter 3 or more characters" formControlName="to">
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="ng-value-icon left" (click)="clear(item, $event)">
            <i class="ng-clear-icon">x</i>
          </span>
          {{ item?.name }} <small>({{ item?.email }})</small>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div>
            <strong>{{ item?.name }}</strong><ng-container> | <small>{{ item?.email }}</small></ng-container>
          </div>
        </ng-template>
      </ng-select>
      @if (!show_bcc) {
        <span class="bcc-label icon-inside-input" (click)="show_bcc = !show_bcc"
        style="cursor: pointer">Bcc</span>
      }
    </div>
    <!-- Cc -->
    <div class="field-row">
      <button class="btn btn-outline-primary to-btn" style="margin-right: 10px" type="button">Cc</button>
      <ng-select class="email-input" [items]="cc_values" bindLabel="email" bindValue="email" [multiple]="true"
        [hideSelected]="true" [minTermLength]="2" [virtualScroll]="true" [minTermLength]="3"
        typeToSearchText="Please enter 3 or more characters" formControlName="cc">
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="ng-value-icon left" (click)="clear(item, $event)">
            <i class="ng-clear-icon">x</i>
          </span>
          {{ item?.name }} <small>({{ item?.email }})</small>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div>
            <strong>{{ item?.name }}</strong><ng-container> | <small>{{ item?.email }}</small></ng-container>
          </div>
        </ng-template>
      </ng-select>
    </div>
    <!-- Bcc -->
    @if (show_bcc) {
      <div class="field-row">
        <button class="btn btn-outline-primary to-btn" style="margin-right: 10px" type="button">Bcc</button>
        <ng-select class="email-input" [items]="bcc_values" bindLabel="email" bindValue="email" [multiple]="true"
          [hideSelected]="true" [minTermLength]="2" [virtualScroll]="true" [minTermLength]="3"
          typeToSearchText="Please enter 3 or more characters" formControlName="bcc">
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-icon left" (click)="clear(item, $event)">
              <i class="ng-clear-icon">x</i>
            </span>
            {{ item?.name }} <small>{{ item?.email }}</small>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div>
              <strong>{{ item?.name }}</strong><ng-container> | <small>{{ item?.email }}</small></ng-container>
            </div>
          </ng-template>
        </ng-select>
      </div>
    }
    <!-- Subject -->
    <div class="field-row">
      <input type="text" class="subject-input" formControlName="subject" placeholder="Add a subject" />
    </div>
    <!-- File Attachments -->
    <div class="field-row">
      <!-- <div class="attachment-section"> -->
      <label for="file-upload" class="btn btn-outline-secondary btn-sm" style="display: inline-block; width:150px">
        <i class="fa-solid fa-paperclip"></i> Attach Files
      </label>
      <input id="file-upload" type="file" multiple (change)="onFileSelected($event)" style="display: none;">

      @if (selectedFiles.length > 0) {
        <div class="selected-files">
          @for (file of selectedFiles; track file; let i = $index) {
            <div class="file-chip" (dblclick)="previewFile(file)"
              title="Double-click to preview">
              <span class="file-name">{{ file.name }}</span>
              <span class="remove-file" (click)="removeFile(i)">&times;</span>
            </div>
          }
        </div>
      }
    <!-- </div> -->
  </div>
  <div class="email-body">
    <ckeditor [editorUrl]="editorUrl" [config]="editorConfig" formControlName="body">
    </ckeditor>
  </div>
</form>
</div>
